export const config = {
    // android (your ip of IoT server must be here) */
    IOT_REST_SERVER_PREFIX: 'api',

    IOT_SERVER_IP_WEB: 'uros.plutonpower.com', //'localhost',
    IOT_SERVER_PORT_WEB: '80',

    IOT_SERVER_IP_MOBILE: 'uros.plutonpower.com', //'10.1.0.18', //'uros.plutonpower.com' '192.168.1.111', //localhost
    // IOT_SERVER_IP_MOBILE: '172.29.146.193',
    IOT_SERVER_PORT_MOBILE: '80' //'9001', // '80'

    // uros.plutonpower.com:80
    // 10.1.0.18: 9001 - uros
    // 93.103.233.160:9001 - tine
};


// WEBPACK FOOTER //
// ./~/pluton-core/lib/config/apiConfig.js